import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage, injectIntl } from 'react-intl'
import { Auth, Game } from '../../../Core'

import * as settingsActions from '../settings.actions'
import * as audioActions from '../../../Core/Game/AudioContainer/audio.actions'
import * as tutorialActions from '../../../Tutorial/tutorial.actions'

import * as settingsSelectors from '../settings.selectors'
import * as tutorialSelectors from '../../../Tutorial/tutorial.selectors'

/**
 *  Main menu
 */
class SettingsMenuPopup extends React.Component {
  /**
   *  Render menu item
   */
  constructor(props) {
    super(props)
    this.state = {
      stateClass: 'active',
      toggleLang: false,
      soundState: props.soundStatus ? 'off' : 'on',
    }
  }

  desactivateAnyOption() {
    const { addHowlSound } = this.props
    addHowlSound('button_click')
    this.setState({
      toggleLang: false,
    })
  }

  /**
   * [renderLanguages description]
   * @param  {[type]} lang [description]
   * @return {[type]}      [description]
   */
  renderLanguages(lang) {
    const { selectLanguage, locale, addHowlSound } = this.props
    const { toggleLang } = this.state
    let using = locale === lang

    return (
      <li
        className={'sublist--nav__item ' + (using ? 'active' : '')}
        key={lang}
        onClick={() => {
          !using && toggleLang ? selectLanguage(lang) : ''
          addHowlSound('button_click')
        }}
      >
        <span className="lang">
          <FormattedMessage id={`languages.${lang}`} />
        </span>
      </li>
    )
  }

  /**
   *  closeMainMenu
   */
  closeMainMenu() {
    const { addHowlSound, showOnlyHelp, hideHelp, removePopup } = this.props
    addHowlSound('button_click')
    removePopup('settings_menu')
    showOnlyHelp ? hideHelp() : null
  }

  openWindow(link, how) {
    const { addHowlSound } = this.props
    addHowlSound('button_click')
    window.open(link, how)
  }
  renderTutorial(helpMenu) {
    const { isTutorial, endTutorial, userInfo, initTutorial, logout } = this.props
    if (!helpMenu && !isTutorial) {
      return
    }
    return (
      <li
        key="tutorial"
        className="list--nav__item"
        onClick={() => {
          this.desactivateAnyOption()
          this.closeMainMenu()
          !isTutorial ? initTutorial() : userInfo ? endTutorial() : logout()
        }}
      >
        <span className="icon-rocket"></span>
        <span className="text">
          {!isTutorial ? (
            <FormattedMessage id={`settings.tutorial`} />
          ) : (
            <FormattedMessage id={`settings.endTutorial`} />
          )}
        </span>
      </li>
    )
  }

  renderHelp() {
    const { intl } = this.props
    const zendesk = intl.formatMessage({ id: 'settings.zendesk_url' })
    const marsFAQs = intl.formatMessage({ id: 'settings.faqs_url' })
    const fastGuide = intl.formatMessage({ id: 'settings.fg_url' })

    return (
      <React.Fragment>
        <li
          className="list--nav__item"
          onClick={() => {
            this.desactivateAnyOption()
            this.openWindow(marsFAQs, '_blank')
          }}
        >
          <span className="icon-faqs"></span>
          <span className="text">
            <FormattedMessage id={`settings.faqs`} />
          </span>
        </li>
        <li
          className="list--nav__item"
          onClick={() => {
            this.desactivateAnyOption()
            this.openWindow(zendesk, '_blank')
          }}
        >
          <span className="icon-support"></span>
          <span className="text">
            <FormattedMessage id={`settings.soporte`} />
          </span>
        </li>
        <li
          className="list--nav__item"
          onClick={() => {
            this.desactivateAnyOption()
            this.openWindow(fastGuide, '_blank')
          }}
        >
          <span className="icon-info"></span>
          <span className="text">
            <FormattedMessage id={`settings.fastGuide`} />
          </span>
        </li>
        {this.renderTutorial(true)}
      </React.Fragment>
    )
  }

  renderOptions() {
    const {
      logout,
      availableLanguages,
      soundStatus,
      disableAudio,
      isTutorial,
      userInfo,
      toggleShadows,
      shadowState,
    } = this.props
    const { toggleLang, soundState } = this.state

    if (isTutorial && !userInfo) return this.renderHelp()

    return (
      <React.Fragment>
        <li
          key="lang"
          className={'list--nav__item ' + (toggleLang ? 'active' : '')}
          onClick={() => {
            this.desactivateAnyOption()
            this.setState({ toggleLang: !this.state.toggleLang })
          }}
        >
          <span className="icon-language"></span>
          <span className="text">
            <FormattedMessage id={`settings.language`} />
          </span>
          <ul className="sublist--nav">
            {availableLanguages.map((lang) => this.renderLanguages(lang))}
          </ul>
        </li>
        <li
          key="effects"
          className="list--nav__item"
          onClick={() => {
            this.desactivateAnyOption()
            this.setState({ soundState: soundState == 'off' ? 'on' : 'off' })
            disableAudio(!soundStatus)
          }}
        >
          <span className={'icon-effects-' + soundState}></span>
          <span className="text">
            <FormattedMessage id={`settings.effects`} />
          </span>
        </li>
        <li
          className="list--nav__item"
          onClick={() => {
            this.desactivateAnyOption()
            toggleShadows()
          }}
        >
          <span className={shadowState ? 'icon-hd' : 'icon-auto'}></span>
          <span className="text">
            <FormattedMessage id={`settings.${shadowState ? 'enableShadows' : 'disableShadows'}`} />
          </span>
        </li>
        {this.renderTutorial(false)}
        <li
          key="logout"
          className="list--nav__item"
          onClick={() => {
            logout()
          }}
        >
          <span className="icon-exit"></span>
          <span className="text">
            <FormattedMessage id={`settings.log_out`} />
          </span>
        </li>
      </React.Fragment>
    )
  }
  /**
   *  Render component
   */
  render() {
    const { showOnlyHelp } = this.props
    const { stateClass } = this.state
    const className = ['list--nav', stateClass].join(' ').trim()

    return (
      <div className="content">
        <nav className="nav">
          <ul className={className}>
            <li
              key="close"
              className="list--nav__item"
              onClick={() => {
                this.closeMainMenu()
              }}
            >
              <span className="icon-close"></span>
              <span className="text">
                <FormattedMessage id={`settings.close`} />
              </span>
            </li>
            {showOnlyHelp ? this.renderHelp() : this.renderOptions()}
          </ul>
        </nav>
      </div>
    )
  }
}

const mapDispatchToProps = (dispatch) => ({
  logout: bindActionCreators(Auth.actions.logout, dispatch),
  removePopup: bindActionCreators(Game.actions.removePopup, dispatch),
  disableAudio: bindActionCreators(audioActions.disableAudio, dispatch),
  selectLanguage: bindActionCreators(settingsActions.selectLanguage, dispatch),
  setSoundEffects: bindActionCreators(settingsActions.setSoundEffects, dispatch),
  setSoundMusic: bindActionCreators(settingsActions.setSoundMusic, dispatch),
  setSoundBackground: bindActionCreators(settingsActions.setSoundBackground, dispatch),
  hideHelp: bindActionCreators(settingsActions.showHelp, dispatch),
  addHowlSound: bindActionCreators(audioActions.playHowlAudio, dispatch),
  initTutorial: bindActionCreators(tutorialActions.initTutorial, dispatch),
  endTutorial: bindActionCreators(tutorialActions.endTutorial, dispatch),
  toggleShadows: bindActionCreators(settingsActions.toggleShadows, dispatch),
})
const mapStateToProps = (state) => ({
  locale: settingsSelectors.getlocale(state),
  availableLanguages: settingsSelectors.getAvailableLanguages(state),
  soundStatus: Game.selectors.getAudioStatus(state),
  shadowState: settingsSelectors.getShadowState(state),
  userInfo: Auth.selectors.getUserInfo(state),
  showOnlyHelp: settingsSelectors.canShowOnlyHelp(state),
  isTutorial: tutorialSelectors.isTutorialMode(state),
})

SettingsMenuPopup.propTypes = {
  locale: PropTypes.string,
  logout: PropTypes.func,
  toggleShadows: PropTypes.func,
  showOnlyHelp: PropTypes.bool,
  hideHelp: PropTypes.func,
  userInfo: PropTypes.object,
  removePopup: PropTypes.func,
  selectLanguage: PropTypes.func,
  disableAudio: PropTypes.func,
  soundStatus: PropTypes.bool,
  shadowState: PropTypes.bool,
  availableLanguages: PropTypes.array,
  addHowlSound: PropTypes.func,
  initTutorial: PropTypes.func,
  isTutorial: PropTypes.bool,
  endTutorial: PropTypes.func,
}

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(SettingsMenuPopup))
